import axios from "axios";
import { UserModel } from "./_models";

const API_URL = process.env.REACT_APP_API_URL;

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/token/`;

export function getUserByToken(token: string) {
  return axios.post<{ user: UserModel, token: string }>(GET_USER_BY_ACCESSTOKEN_URL, {
    token: token
  });
}
